
function $parcel$extendImportMap(map) {
  Object.assign(parcelRequire.i ??= {}, map);
}

function $parcel$resolve(url) {
  url = parcelRequire.i?.[url] || url;
  return new URL($parcel$distDir + url, import.meta.url).toString();
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var $parcel$distDir = "./";

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
var $991c5748a9922a14$exports = {};
$parcel$extendImportMap({
    "hzhi6": "klecks-service-worker.js"
});

function $ee60efaf9a2d5bcb$export$c96126450dfa597a() {
    if (!('serviceWorker' in navigator) || !window.isSecureContext) return false;
    return true;
}


var $08e0fe1ff49ee3a0$exports = {};
$08e0fe1ff49ee3a0$exports = $parcel$resolve("hzhi6");


// Registering this service worker allows the app to be accessible and
// fully functional when offline (after an initial visit for caching).
if ((0, $ee60efaf9a2d5bcb$export$c96126450dfa597a)()) navigator.serviceWorker.register($08e0fe1ff49ee3a0$exports, {
    // Parcel produces a stable url for the service worker so we must revalidate every time.
    updateViaCache: 'none'
});


//# sourceMappingURL=klecks.9332d42b.js.map
